import { http, ep } from '../../client/http';

export const settingsRepo = {
  get: async () => {
    const res = await http.get(ep('settings'));
    return res.data.data; // <-- artık direkt {logo, favicon, ...} döner
  }
};
